import { render, staticRenderFns } from "./GameTab.vue?vue&type=template&id=7dd36503&scoped=true&"
import script from "./GameTab.vue?vue&type=script&lang=js&"
export * from "./GameTab.vue?vue&type=script&lang=js&"
import style0 from "./GameTab.vue?vue&type=style&index=0&id=7dd36503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd36503",
  null
  
)

export default component.exports